class WakeLockManager {
  private _lockSentinel: WakeLockSentinel | null = null;

  async request() {
    if (this._lockSentinel) {
      return;
    }

    const isSuccess = await this._doRequest();
    if (isSuccess) {
      this._setEventListener();
    }
  }

  async release() {
    if (!this._lockSentinel) {
      return;
    }

    await this._lockSentinel.release();

    this._lockSentinel = null;
    this._clearEventListener();
  }

  private async _doRequest(): Promise<boolean> {
    try {
      this._lockSentinel = await navigator.wakeLock.request('screen');
      return true;
    } catch (e) {
      console.warn('Failed to request wakeLock', e);
      return false;
    }
  }

  private _setEventListener() {
    this._clearEventListener();
    document.addEventListener('visibilitychange', this._handleVisibilityChange);
  }

  private _clearEventListener() {
    document.removeEventListener(
      'visibilitychange',
      this._handleVisibilityChange,
    );
  }

  private _handleVisibilityChange = async () => {
    if (
      this._lockSentinel?.released &&
      document.visibilityState === 'visible'
    ) {
      await this._doRequest();
    }
  };
}

export const wakeLockManager = new WakeLockManager();
